import React from 'react'

import { BaseView } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import { AdaptedGoalTransferDTO } from '@/domain/transfer/transferTypes'
import { useUserStore } from '@/store/useUserStore'

interface TransferDetailsAvatarProps extends Partial<AdaptedGoalTransferDTO> {
  isLoading?: boolean
}

export const TransferDetailsAvatar: React.FC<TransferDetailsAvatarProps> = ({
  amount,
  displayIconBgColor,
  displayIconName,
  isLoading = false,
}) => {
  // All hooks must be called before any conditional logic
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Get currency data
  const walletData = completeCurrencies?.find(
    (currency) => currency.code === (amount?.currency || 'USDT'),
  )

  const adaptedIconBgColor = displayIconBgColor || walletData?.avatarBGRefColor
  const shouldRenderCurrencyIcon = !displayIconName

  return (
    <BaseView center>
      <Avatar
        skeletonActive={isLoading}
        isCurrency={shouldRenderCurrencyIcon}
        iconName={!shouldRenderCurrencyIcon ? displayIconName : undefined}
        uri={shouldRenderCurrencyIcon ? walletData?.icon : undefined}
        size={120}
        iconSize={60}
        bgColor={adaptedIconBgColor}
        containerGradientProps={
          Array.isArray(adaptedIconBgColor)
            ? {
                locations: undefined,
                start: { x: 0.1, y: 0 },
                end: { x: 1, y: 1 },
              }
            : undefined
        }
      />
    </BaseView>
  )
}
